// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"276":"f7256524","357":"09772295"}[chunkId] + ".js";
};